import {
  BreakpointQueryName, FontWeight, SpacingName, ThemedFunctor, TypographyName, getSpacing, getTypography,
} from '@doveit/lego';
import { css } from 'styled-components';
import { WrapperSize } from '../../types';

export const text: ThemedFunctor = ({ theme }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.LG)} {
    text-align: center;
  }
`;

// COMMON

export const divider: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
  margin: 0 auto;
  max-width: ${WrapperSize.L};

  &::before {
    content: '';
    height: 1px;
    width: calc(100% + ${theme.spaceUnits.desktop.MEDIUM} + ${theme.spaceUnits.desktop.MEDIUM});
    background-color: ${theme.palettes.neutrals.light};
    display: block;
    transform: translateX(${theme.spaceUnits.desktop['-MEDIUM']});
  }
`;

// INTRO

export const introImage = () => css`
  width: 15rem;
`;

// ADVANTAGES SECTION

export const advantagesTitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, SpacingName.AUTO, 0])}
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
  max-width: ${WrapperSize.L};

  ${text({ theme })}
`;

export const advantagesSubtitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2, { fontWeight: FontWeight.LIGHT })}
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
  ${getSpacing.margin(theme, [0, SpacingName.AUTO, SpacingName.BIGGER])}
  max-width: ${WrapperSize.L};

  ${text({ theme })}
`;

export const supportImageWrapper: ThemedFunctor = () => css`
  max-width: 27rem;
`;

export const networkDetails: ThemedFunctor = () => css`
  max-width: 54rem;
`;

// REPUTATION SECTION

export const reputationTitle: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H2)}
  ${getSpacing.margin(theme, [SpacingName.MEDIUM, SpacingName.AUTO, 0])}
  ${getSpacing.padding(theme, [0, SpacingName.SMALL])}
  max-width: ${WrapperSize.L};

  ${text({ theme })}
`;

export const reputationTrustBox: ThemedFunctor = () => css`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
